export default __webpack_public_path__ + "static/media/36I-102800_-15983_0.3d49e83f.jpg";